import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import i18n from '../i18n'

export const useLanguageStore = defineStore('language', () => {
  // Available languages in the application
  const availableLanguages = [
    { code: 'en', name: 'English' },
    { code: 'vi', name: 'Tiếng Việt' }
  ]
  
  // Get locale from localStorage or default to 'en'
  const currentLang = ref(localStorage.getItem('locale') || 'en')

  // Function to change the language
  function setLanguage(locale) {
    if (!availableLanguages.some(lang => lang.code === locale)) {
      console.error(`Unsupported locale: ${locale}`)
      return
    }

    // Update state
    currentLang.value = locale

    // Update localStorage
    localStorage.setItem('locale', locale)

    // Update i18n locale
    i18n.global.locale.value = locale
  }

  return {
    availableLanguages,
    currentLang,
    setLanguage
  }
})